import React, { FunctionComponent } from "react";

import { CustomPart } from "../../../stores/slices/packageEditorSlice";
import { CustomPartItem } from "./CustomPartItem";

export const CustomParts: FunctionComponent<{
  customParts: CustomPart[];
  removeCustomPart(customPartNumber: string): void;
  updateCustomPart(customPart: CustomPart): void;
}> = ({ customParts, removeCustomPart, updateCustomPart }) => {
  return customParts.map((part) => (
    <CustomPartItem
      key={part.customPartNumber}
      part={part}
      removeCustomPart={removeCustomPart}
      updateCustomPart={updateCustomPart}
    />
  ));
};
